import { render, staticRenderFns } from "./FirebaseLogin.vue?vue&type=template&id=f843b1b2&scoped=true&"
import script from "./FirebaseLogin.vue?vue&type=script&lang=ts&"
export * from "./FirebaseLogin.vue?vue&type=script&lang=ts&"
import style0 from "./FirebaseLogin.vue?vue&type=style&index=0&id=f843b1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f843b1b2",
  null
  
)

export default component.exports